// extracted by mini-css-extract-plugin
export default {"container":"LpSwipeQuestionReport_container__WUPfl","innerContainer":"LpSwipeQuestionReport_innerContainer__8J1qM"};